import { VoucherFormBanner } from '../../components/VoucherForm/Banner';
import { VoucherFormBooking } from '../../components/VoucherForm/Booking';
import { VoucherFormProvider } from '../../components/VoucherForm/Context';
import { VoucherFormDiscount } from '../../components/VoucherForm/Discount';
import { VoucherFormInformation } from '../../components/VoucherForm/Information';
import { VoucherFormQuantity } from '../../components/VoucherForm/Quantity';
import VoucherFormCustomer from '../../components/VoucherForm/Rules/AllowedCustomer/VoucherFormCustomer';
import { VoucherFormStructure } from '../../components/VoucherForm/Structure';
import { VoucherFormSubmit } from '../../components/VoucherForm/Submit';

import styles from './add-voucher.module.scss';

const AddUxPage = () => {
  const VoucherFormInformationTemplate = {
    revenueType: 'Marketing',
    voucherType: 'UX',
    reasonField: false,
  };

  const VoucherFormStructureTemplate = {
    length: 12,
  };

  const VoucherFormDiscountTemplate = {
    disabled: false,
    discountType: 'percentage_marketing',
    showFreeAncillaries: true,
    excludeTypes: ['credit_amount', 'free_ride_hybrid', 'value_hybrid'],
  };

  const VoucherFormBookingTemplate = {
    usageType: 'single',
    disableAllowedPlatforms: true,
    disableValidity: true,
  };

  return (
    <>
      <VoucherFormBanner title='UX Research Incentive' />
      <VoucherFormProvider>
        <form>
          <div className={styles.container}>
            <VoucherFormInformation template={VoucherFormInformationTemplate} />
            <VoucherFormQuantity />
            <VoucherFormStructure template={VoucherFormStructureTemplate} />
            <VoucherFormDiscount template={VoucherFormDiscountTemplate} />
            <VoucherFormBooking template={VoucherFormBookingTemplate} />
            <VoucherFormCustomer />
          </div>
          <VoucherFormSubmit />
        </form>
      </VoucherFormProvider>
    </>
  );
};

export default AddUxPage;
